import RadioGroup from "Shared/RadioGroup";
import RadioInput from "Shared/RadioGroup/RadioInput";
import React from "react";
import { useTranslation } from "react-i18next";
import useSelector from "src/utils/useSelector";
import { Yn } from "Types/TradeIn";

export const TradePendingHeader = ({ onChange }: { onChange: (id: string, value: "no" | "yes") => void }) => {
    const { t } = useTranslation();
    const hasTradeIn = useSelector((state) => state.tradeIn.yn === Yn.Yes);
    return (
        <div
            className="TradePending__header--container"
            id="TradePendingGroup"
            data-e2e="tradePendingSection"
            key={`${hasTradeIn}`}
        >
            <p className="TradePending__header">{t("TradePending.question")}</p>
            <RadioGroup onChange={onChange} name="TradePendingBoolean">
                <RadioInput label={t("TradePending.yes")} id="TradePendingYes" value="yes" isDefault={hasTradeIn} />
                <RadioInput label={t("TradePending.no")} id="TradePendingNo" value="no" isDefault={!hasTradeIn} />
            </RadioGroup>
        </div>
    );
};
